import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const GatePassPluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default GatePassPluginPage